module.exports = __webpack_public_path__ + "media/icons/marki-modele@3x-b80a0701.svg";